export var ServiceBase = (function () {
    function ServiceBase() {
    }
    ServiceBase.prototype.cleanFirebaseObject = function (obj) {
        delete obj['$key'];
        delete obj['$value'];
        delete obj['$exists'];
    };
    return ServiceBase;
}());
export var KeyPair = (function () {
    function KeyPair(key) {
        this.value = true;
        this.key = key;
    }
    return KeyPair;
}());
